import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import swal from "sweetalert";
import { useDispatch, useSelector } from "react-redux";
import Geolocation from "react-geolocation";
import axios from "axios";
import {
  GET_TOKEN,
  API_TIMEOUT,
  GET_DAFTARHADIR_LIBUR,
  GET_DAFTARHADIR_KOORDINATOPD,
  GET_INSTANSI,
  API_DAFTARHADIR_SHIFT,
  API_DAFTARHADIR_SHIFT_CEK,
  API_DAFTARHADIR_ATURAN_SHIFT,
  API_DAFTARHADIR_PULANG_SHIFT,
} from "utils";
import { getUserDHO } from "actions/GetUserAction";
import {
  catatMasuk,
  catatPulang,
  clearCatatPulang,
} from "actions/DaftarHadirAction";
import { dateTime } from "utils";
import { GET_DH_ATURAN } from "utils";
import { getTimeKu } from "utils";
import { parseDateSafe } from "utils";
import {
  getCurrentPositionEnhanced,
  validateCoordinates,
  getCurrentTimeEnhanced,
  isIOS,
  isSafari,
  getDeviceInfo,
} from "utils/geolocation";

export default function CatatDH() {
  const dispatch = useDispatch();

  const { catatMasukResult, catatPulangResult } = useSelector(
    (state) => state.DaftarHadirReducer
  );
  const history = useHistory();

  const [unitKerja, setUnitKerja] = useState("");
  const [nama, setNama] = useState("");
  const [waktuMasukKu, setWaktuMasukKu] = useState("");

  const [waktuPulang, setWaktuPulang] = useState("");
  const [status, setStatus] = useState("");
  const [avatar, setAvatar] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [workingHours, setWorkingHours] = useState(0);
  const [idDH, setIdDH] = useState("");
  const [edit, setEdit] = useState(false);
  const [dateTimeKu, setDateTimeKu] = useState("");
  const [uid, setUid] = useState("");
  const [tanggal, setTanggal] = useState("");
  const [bulan, setBulan] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [sementaraLoading, setSementaraLoading] = useState(false);

  const [hariIni, sethariIni] = useState("");
  const [tahun, setTahun] = useState("");
  const [labelBulan, setLabelBulan] = useState("");

  const [catatMasukKu, setCatatMasukKu] = useState(false);
  const [catatPulangkuKu, setCatatPulangKu] = useState(false);

  const [aturanMasuk, setAturanMasuk] = useState("");
  const [aturanPulang, setAturanPulang] = useState("");
  const [jarakMasuk, setJarakMasuk] = useState(0);
  const [jarakPulang, setJarakPulang] = useState(0);
  const [shiftType, setShiftType] = useState(""); // pagi, siang, malam

  const [libur, setLibur] = useState(false);
  const [hariLibur, setHariLibur] = useState("");

  // auth
  const [coordsKantor, setcoordsKantor] = useState({
    lat: null,
    long: null,
  });

  const [accessToken, setAccessToken] = useState("");

  // Enhanced Geolocation state untuk cross-platform compatibility
  const [geolocationSupported, setGeolocationSupported] = useState(false);
  const [geolocationError, setGeolocationError] = useState("");
  const [isGettingLocation, setIsGettingLocation] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [jarakKeKantor, setJarakKeKantor] = useState(0);

  const refreshToken = async () => {
    console.log("Refresh token untuk shift:", shiftType);
    try {
      const response = await axios.get(GET_TOKEN + "/token", {
        credentials: "include",
      });
      setAccessToken(response.data.accessToken);
    } catch (error) {
      console.error("Error refresh token untuk shift:", shiftType, error);
      if (error.response) {
        history.push("/admin/daftarhadir");
      }
    }
  };

  // Enhanced Geolocation untuk cross-platform compatibility dengan iOS/iPhone support
  const getCurrentLocation = async () => {
    console.log("Get current location untuk shift:", shiftType);
    setIsGettingLocation(true);
    setGeolocationError("");
    console.log("Getting location dimulai untuk shift:", shiftType);
    console.log("Geolocation error reset untuk shift:", shiftType);

    try {
      // Get device info for debugging
      const device = getDeviceInfo();
      setDeviceInfo(device);
      console.log("Device Info untuk shift:", shiftType, device);
      console.log("Device info set untuk shift:", shiftType);

      const position = await getCurrentPositionEnhanced();

      if (validateCoordinates(position.latitude, position.longitude)) {
        setLatitude(position.latitude);
        setLongitude(position.longitude);
        setGeolocationSupported(true);
        console.log("Geolocation supported untuk shift:", shiftType);
        console.log("Latitude set untuk shift:", shiftType);
        console.log("Longitude set untuk shift:", shiftType);

        if (validateCoordinates(coordsKantor.lat, coordsKantor.long)) {
          const jarak = calcCrow(
            position.latitude,
            position.longitude,
            coordsKantor.lat,
            coordsKantor.long
          );
          setJarakKeKantor(jarak);
          console.log("Jarak normal set untuk shift:", shiftType);
          console.log("Jarak ke kantor:", jarak, "km");
        }

        console.log("Location obtained successfully:", position);
        console.log("Shift type:", shiftType);
      } else {
        throw new Error(`Koordinat tidak valid untuk shift: ${shiftType}`);
      }
    } catch (error) {
      console.error("Geolocation error untuk shift:", shiftType, error);
      setGeolocationSupported(false);
      setGeolocationError(error.message + (shiftType ? ` (${shiftType})` : ""));
      setLatitude("");
      setLongitude("");
      setJarakKeKantor(0);
    } finally {
      setIsGettingLocation(false);
      console.log("Getting location selesai untuk shift:", shiftType);
    }
  };

  // Enhanced time validation untuk cross-platform dengan iOS compatibility
  const getCurrentTime = () => {
    console.log("Get current time untuk shift:", shiftType);
    try {
      return getCurrentTimeEnhanced();
    } catch (error) {
      console.error("Time error untuk shift:", shiftType, error);
      // Fallback ke method lama jika ada error
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      return {
        year,
        month,
        day,
        hours,
        minutes,
        seconds,
        fullDate: `${year}-${month}-${day}`,
        timeString: `${hours}:${minutes}`,
        timeStringWithSeconds: `${hours}:${minutes}:${seconds}`,
        dateTime: now,
      };
    }
  };

  //verifikasi

  const verifikasi = () => {
    console.log("Verifikasi dimulai untuk shift:", shiftType);
    if (catatMasukKu) {
      var limitPagi = aturanMasuk;

      const currentTime = getCurrentTime();
      const { year, month, day, hours, minutes, seconds, fullDate } =
        currentTime;

      var waktuAbsen = `${hours}:${minutes}`;
      var recentTime = `${waktuAbsen}:${seconds}`;

      var recentTimeFormat = parseDateSafe(
        `${year}-${month}-${day}T${recentTime}`
      );
      var limitPagiTimeFormat = parseDateSafe(
        `${year}-${month}-${day}T${
          limitPagi && String(limitPagi).length === 5
            ? limitPagi + ":00"
            : limitPagi
        }`
      );
      var tanggalDH = fullDate;

      if (recentTimeFormat > limitPagiTimeFormat && status == "Hadir") {
        swal(
          "Failed",
          "Anda telat tidak bisa melakukan pencatatan masuk" +
            (shiftType ? ` pada ${shiftType}` : ""),
          "error"
        );

        return;
      }

      // Enhanced distance calculation dengan validasi koordinat
      if (
        validateCoordinates(latitude, longitude) &&
        validateCoordinates(coordsKantor.lat, coordsKantor.long)
      ) {
        const jarak = calcCrow(
          latitude,
          longitude,
          coordsKantor.lat,
          coordsKantor.long
        );

        // Update jarak ke kantor untuk ditampilkan
        setJarakKeKantor(jarak);
        console.log("Verifikasi jarak untuk shift:", shiftType);
        console.log("Jarak verifikasi set untuk shift:", shiftType);

        if (jarak > jarakMasuk && status == "Hadir") {
          swal(
            "Failed",
            "Posisi anda berjarak " +
              jarak.toFixed(2) +
              " km dari lokasi kerja" +
              (shiftType ? ` pada ${shiftType}` : "") +
              ". Status Hadir tidak bisa dicatat ke database",
            "error"
          );

          return;
        }
      } else {
        console.warn(
          "Invalid coordinates detected untuk shift:",
          shiftType,
          "skipping distance validation"
        );
      }

      catatMasuk(month, day, year, waktuAbsen, tanggalDH);
    } else {
      var limitPulang = aturanPulang;
      const currentTime = getCurrentTime();
      const { year, month, day, hours, minutes, seconds } = currentTime;

      var waktuAbsenPulang = `${hours}:${minutes}:${seconds}`;
      var recentTime = waktuAbsenPulang;
      var waktuMasukModif =
        waktuMasukKu && String(waktuMasukKu).length === 5
          ? waktuMasukKu + ":00"
          : waktuMasukKu;
      const waktuAbsenPulangKu = `${hours}:${minutes}`;
      var recentTimeFormat = parseDateSafe(`2023-11-11T${recentTime}`);
      var limitPulangNorm =
        limitPulang && String(limitPulang).length === 5
          ? limitPulang + ":00"
          : limitPulang;
      var limitPulangTimeFormat = parseDateSafe(
        `2023-11-11T${limitPulangNorm}`
      );

      var waktuPulangTimeFormat = parseDateSafe(`2023-11-11T${recentTime}`);

      var waktuMasukTimeFormat = parseDateSafe(
        `2023-11-11T${waktuMasukModif}`
      );

      var timeku = Math.round(
        waktuPulangTimeFormat.getHours() - waktuMasukTimeFormat.getHours()
      );
      var menitku = Math.round(
        waktuPulangTimeFormat.getMinutes() - waktuMasukTimeFormat.getMinutes()
      );

      timeku = Math.abs(timeku);
      timeku = timeku * 60;
      var whKu = timeku + menitku;
      var whKu2 = whKu / 60;

      whKu2 = whKu2.toFixed(2);
      var whKuString = whKu2.toString().split(".");
      var menitku2 = "0" + "." + whKuString[1];
      var menitku3 = parseFloat(menitku2);
      var menitku4 = menitku3 * 60;
      menitku4 = menitku4.toFixed(0);

      var jamKerja = whKuString[0] + ":" + menitku4;

      if (recentTimeFormat < limitPulangTimeFormat) {
        swal(
          "Failed",
          " Belum waktu pulang, tidak bisa melakukan  pencatatan pulang" +
            (shiftType ? ` pada ${shiftType}` : ""),
          "error"
        );

        return;
      }

      // Enhanced distance calculation untuk pulang
      if (
        validateCoordinates(latitude, longitude) &&
        validateCoordinates(coordsKantor.lat, coordsKantor.long)
      ) {
        const jarak = calcCrow(
          latitude,
          longitude,
          coordsKantor.lat,
          coordsKantor.long
        );

        // Update jarak ke kantor untuk ditampilkan
        setJarakKeKantor(jarak);
        console.log("Verifikasi jarak pulang untuk shift:", shiftType);
        console.log("Jarak verifikasi pulang set untuk shift:", shiftType);

        if (jarak > jarakMasuk) {
          swal(
            "Failed",
            " Posisi anda berjarak " +
              jarak.toFixed(2) +
              " km dari lokasi kerja" +
              (shiftType ? ` pada ${shiftType}` : "") +
              ". Status Hadir tidak bisa dicatat ke database",
            "error"
          );

          return;
        }
      } else {
        console.warn(
          "Invalid coordinates detected for logout untuk shift:",
          shiftType,
          "skipping distance validation"
        );
      }

      editDH(year, month, day, waktuAbsenPulangKu, jamKerja);
    }
  };

  //verifikasi

  //dari Smart service

  //This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
  function calcCrow(lat1, lon1, lat2, lon2) {
    console.log("Calc crow untuk shift:", shiftType);
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }

  // Converts numeric degrees to radians
  function toRad(Value) {
    console.log("To rad untuk shift:", shiftType);
    return (Value * Math.PI) / 180;
  }

  const ambilAturan = (hariKerja, aturan) => {
    console.log("Ambil aturan untuk shift:", shiftType);
    axios({
      method: "get",
      url: API_DAFTARHADIR_ATURAN_SHIFT,
      timeout: API_TIMEOUT,
      headers: {
        Authorization: `Bearer ${accessToken || ""}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          alert("errorr");
        } else {
          //BERHASIL
          const data1 = response.data.data;

          setAturanMasuk(data1[0].jamMasuk);
          setAturanPulang(data1[0].jamKeluar);
          setJarakMasuk(data1[0].jarakMasuk);
          setJarakPulang(data1[0].jarakKeluar);
          console.log("Aturan masuk set untuk shift:", shiftType);
          console.log("Aturan pulang set untuk shift:", shiftType);
          console.log("Jarak masuk set untuk shift:", shiftType);
          console.log("Jarak pulang set untuk shift:", shiftType);
          setShiftType(data1[0].shiftType); // pagi, siang, malam
          console.log("Aturan shift loaded:", data1[0].shiftType);
          console.log("Shift type set untuk shift:", data1[0].shiftType);
        }
      })
      .catch((error) => {
        // ERROR
        console.error("Error ambil aturan untuk shift:", shiftType, error);
        alert(error.message);
      });
  };

  const cekLibur = (tanggal) => {
    console.log("Cek libur untuk shift:", shiftType);
    axios({
      method: "get",
      url: GET_DAFTARHADIR_LIBUR + `${tanggal}`,
      timeout: API_TIMEOUT,
      headers: {
        Authorization: `Bearer ${accessToken || ""}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          alert("errorr");
        } else {
          //BERHASIL
          const data1 = response.data.data;

          if (data1.length > 0) {
            setHariLibur(data1[0].libur);
            setLibur(true);
            // Disable tombol catat masuk jika libur
            setCatatMasukKu(false);
            console.log("Libur set untuk shift:", shiftType);
            console.log("Hari libur set untuk shift:", shiftType);
          } else {
            setLibur(false);
            setHariLibur("");
            console.log("Tidak libur untuk shift:", shiftType);
          }
        }
      })
      .catch((error) => {
        // ERROR
        console.error("Error cek libur untuk shift:", shiftType, error);
        alert(error.message);
      });
  };

  //Smartservice

  const getTanggal = (date) => {
    console.log("Get tanggal untuk shift:", shiftType);
    var month = date.getMonth() + 1;
    month = month.toString();

    if (month.length == 1) {
      month = "0" + month;
    }
    var day = date.getDate().toString();
    if (day.length === 1) {
      day = "0" + day;
    }
    var year = date.getFullYear().toString();
    var tanggalKu = year + "-" + month + "-" + day;

    let hariIniKu = dateTime(date);

    var indexHari = date.getDay();

    ambilStatusPD(unitKerja, indexHari, tanggalKu);

    sethariIni(hariIniKu);
    setLabelBulan(month);
    setTahun(year);

    setBulan(month);
    setTanggal(tanggalKu);
    console.log("Tanggal data set untuk shift:", shiftType);
  };

  //auth

  const getTime = () => {
    console.log("Get time untuk shift:", shiftType);
    const data = getTimeKu();
    setDateTimeKu(data.datetime);
    console.log("DateTime set untuk shift:", shiftType);
  };
  useEffect(() => {
    if (dateTimeKu) {
      getTanggal(parseDateSafe(dateTimeKu));
    }
  }, [dateTimeKu]);

  //edit masuk

  //catat masuk

  const catatMasuk = (month, day, year, waktuAbsen, tanggalDH) => {
    console.log("Catat masuk untuk shift:", shiftType);
    var wM = "";
    if (waktuMasukKu) {
      wM = waktuMasukKu;
      wM = wM.split(":");
      wM = wM[0] + ":" + wM[1];
    }

    var wP = "";

    axios({
      method: "post",
      url: API_DAFTARHADIR_SHIFT,
      timeout: API_TIMEOUT,
      data: {
        tahun: year,
        bulan: month,
        tanggal: tanggalDH,
        nama: nama,
        opd: unitKerja,
        waktuMasuk: waktuAbsen,
        waktuPulang: wP,
        status: status,
        koordinatMasuk: latitude + "," + longitude,
        koordinatPulang: "",
        workingHours: "",
        token: "",
        idUser: uid,
        statusAdmin: true,
        shiftType: shiftType, // tambahan untuk shift
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          alert("error");
        } else {
          //BERHASIL

          var dataKirim = {
            id: response.data.data.insertId,
            status: status,
          };

          swal(
            "Success",
            "Soda Molek " +
              nama +
              " Pencatatan kehadiran berhasil dilakukan dengan status " +
              status +
              (shiftType ? ` pada ${shiftType}` : "") +
              ". Terima kasih",
            "success"
          );
          history.push("/admin/daftarhadir");
        }
      })
      .catch((error) => {
        // ERROR
        console.error("Error catat masuk untuk shift:", shiftType, error);
        alert(error);

        //alert(error);
      });
  };

  const editDH = (year, month, day, waktuAbsenPulang, jamKerja) => {
    console.log("Edit DH untuk shift:", shiftType);
    var wM = "";
    if (waktuMasukKu) {
      wM = waktuMasukKu;
      wM = wM.split(":");
      wM = wM[0] + ":" + wM[1];
    }

    axios({
      method: "post",
      url: API_DAFTARHADIR_PULANG_SHIFT,
      timeout: API_TIMEOUT,
      data: {
        waktuMasuk: wM,
        waktuPulang: waktuAbsenPulang,
        status: status,
        koordinatPulang: latitude + "," + longitude,
        workingHours: jamKerja,
        id: idDH,
        statusAdmin: true,
        shiftType: shiftType, // tambahan untuk shift
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          alert("error");
        } else {
          //BERHASIL

          swal(
            "Success",
            "Soda Molek " +
              nama +
              " Pcdatatan pulang berhasil dilakukan. Jam kerja anda adalah " +
              jamKerja +
              (shiftType ? ` pada ${shiftType}` : "") +
              ". Terima kasih atas kontribusinya dalam pelaksanaan tugas hari ini",
            "success"
          );
          history.push("/admin/daftarhadir");
        }
      })
      .catch((error) => {
        // ERROR
        console.error("Error edit DH untuk shift:", shiftType, error);
        alert(error);

        //alert(error);
      });
  };

  //catatMasuk

  //ceck catatan masuk

  const cekCatatanMasuk = (dataKirim) => {
    console.log("Cek catatan masuk untuk shift:", shiftType);
    setSementaraLoading(true);
    console.log("Sementara loading dimulai untuk shift:", shiftType);
    axios({
      method: "post",
      url: API_DAFTARHADIR_SHIFT_CEK,
      timeout: API_TIMEOUT,
      headers: {
        Authorization: `Bearer ${accessToken || ""}`,
      },
      data: {
        tanggal: dataKirim.tanggal,
        idUser: uid,
        shiftType: shiftType, // tambahan untuk shift
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL
          const cekCatatanResult =
            response.data.data.length > 0 ? response.data.data[0] : [];

          if (cekCatatanResult.id) {
            setStatus(cekCatatanResult.status);
            console.log("Status set untuk shift:", shiftType);

            setWaktuMasukKu(cekCatatanResult.waktuMasuk);
            setWaktuPulang(cekCatatanResult.waktuPulang);
            setWorkingHours(cekCatatanResult.workingHours);
            setEdit(true);
            setIdDH(cekCatatanResult.id);
            console.log("Waktu masuk set untuk shift:", shiftType);
            console.log("Waktu pulang set untuk shift:", shiftType);
            console.log("Working hours set untuk shift:", shiftType);
            console.log("Edit set untuk shift:", shiftType);
            console.log("ID DH set untuk shift:", shiftType);

            if (
              cekCatatanResult.waktuPulang == "" &&
              cekCatatanResult.status == "Hadir"
            ) {
              setCatatMasukKu(false);
              setCatatPulangKu(true);
              console.log("Catat pulang set untuk shift:", shiftType);
            } else {
              setCatatMasukKu(false);
              setCatatPulangKu(false);
              console.log("Tidak ada catatan untuk shift:", shiftType);
            }
          } else {
            setCatatMasukKu(true);
            setCatatPulangKu(false);
            console.log("Status catatan masuk untuk shift:", shiftType);
            console.log("Catat masuk set untuk shift:", shiftType);
          }
        }
      })
      .catch((error) => {
        // ERROR
        console.error("Error cek catatan masuk untuk shift:", shiftType, error);
        alert(error);
      });

    setSementaraLoading(false);
    console.log("Sementara loading selesai untuk shift:", shiftType);
  };

  //aafadf

  const ambilStatusPD = (unitKerja, indexHari, hariIni) => {
    console.log("Ambil status PD untuk shift:", shiftType);
    axios({
      method: "get",
      url: GET_DAFTARHADIR_KOORDINATOPD + `${unitKerja}`,
      timeout: API_TIMEOUT,
      headers: {
        Authorization: `Bearer ${accessToken || ""}`,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          alert("errorr");
        } else {
          //BERHASIL
          const data2 = response.data.data;

          const koordinat = data2[0].koordinatKantor.split(",");
          const lat = parseFloat(koordinat[0]);
          const long = parseFloat(koordinat[1]);
          setcoordsKantor({
            lat: lat,
            long: long,
          });
          console.log("Koordinat kantor set untuk shift:", shiftType);

          let aturan = "";
          const status = data2[0].hariKerja;

          if (status == 6) {
            aturan = "aturan6hari";

            if (indexHari == 0) {
              setLibur(true);
              setHariLibur("Weekend");
              console.log("Weekend set untuk shift:", shiftType);
            } else {
              cekLibur(hariIni);
              ambilAturan(indexHari, aturan);
              var dataKirim = { tanggal: hariIni };

              cekCatatanMasuk(dataKirim);
              console.log("Status PD untuk shift 6 hari:", shiftType);
            }
          } else {
            aturan = "aturan";
            //
            if (indexHari == 0 || indexHari == 6) {
              setLibur(true);
              setHariLibur("Weekend");
              console.log("Weekend set untuk shift:", shiftType);
            } else {
              cekLibur(hariIni);
              ambilAturan(indexHari, aturan);
              var dataKirim = { tanggal: hariIni };

              cekCatatanMasuk(dataKirim);
              console.log("Status PD untuk shift 5 hari:", shiftType);
            }
          }
        }
      })
      .catch((error) => {
        // ERROR
        console.error("Error ambil status PD untuk shift:", shiftType, error);
        alert(error.message);
      });
  };

  useEffect(() => {
    const user = JSON.parse(window.localStorage.getItem("user"));
    setUid(user.uid);
    setNama(user.nama);
    setAvatar(user.avatar);
    setUnitKerja(user.unitKerja);
    console.log("User data set untuk shift:", shiftType);

    getTime();

    // Auto-get location on component mount dengan delay untuk iOS
    setTimeout(() => {
      getCurrentLocation();
      console.log("Component mounted untuk shift:", shiftType);
    }, 1000);
  }, []);

  useEffect(() => {
    if (
      validateCoordinates(latitude, longitude) &&
      validateCoordinates(coordsKantor.lat, coordsKantor.long)
    ) {
      setJarakKeKantor(
        calcCrow(latitude, longitude, coordsKantor.lat, coordsKantor.long)
      );
    }
  }, [latitude, longitude, coordsKantor]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaveLoading(true);
    console.log("Save loading dimulai untuk shift:", shiftType);

    if (status) {
      //action
      // this.props.dispatch(updateJersey(this.state));

      verifikasi();
      console.log("Submit untuk shift:", shiftType);
      console.log("Status valid untuk shift:", shiftType);
    } else {
      swal(
        "Failed",
        "Maaf semua form wajib diisi" +
          (shiftType ? ` untuk ${shiftType}` : ""),
        "error"
      );
    }
    setSaveLoading(false);
    console.log("Save loading selesai untuk shift:", shiftType);
  };

  return (
    <div
      className="content"
      style={{
        background: "#f8f9fa",
        minHeight: "100vh",
        padding: "30px",
      }}
    >
      {/* Header Section */}
      <Row className="mb-4">
        <Col>
          <Link
            to="/admin/daftarhadir"
            className="btn btn-outline-primary"
            style={{
              borderRadius: "8px",
              padding: "12px 24px",
              textDecoration: "none",
              transition: "all 0.3s ease",
              border: "2px solid #007bff",
              color: "#007bff",
              fontWeight: "500",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#007bff";
              e.target.style.color = "white";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.color = "#007bff";
              e.target.style.transform = "translateY(0)";
            }}
          >
            <i className="nc-icon nc-minimal-left mr-2"></i>
            Kembali {shiftType && `(${shiftType})`}
          </Link>
        </Col>
      </Row>

      {/* Main Card */}
      <Row>
        <Col>
          <div
            style={{
              background: "white",
              borderRadius: "16px",
              padding: "40px",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
              border: "1px solid #e9ecef",
            }}
          >
            {/* Header */}
            <div className="text-center mb-5">
              <h2
                style={{
                  color: "#2c3e50",
                  fontSize: "2.2rem",
                  fontWeight: "700",
                  marginBottom: "15px",
                }}
              >
                {hariIni.tanggalLengkap}
                {hariIni.tanggalLengkap &&
                  console.log("Hari ini aktif untuk shift:", shiftType)}
              </h2>
              {shiftType && (
                <div
                  style={{
                    marginBottom: "15px",
                    fontSize: "1rem",
                    color: "#6c757d",
                    fontWeight: "500",
                  }}
                >
                  Sistem Absensi Shift Kerja
                </div>
              )}
              <div
                style={{
                  width: "80px",
                  height: "4px",
                  background: "#007bff",
                  margin: "0 auto",
                  borderRadius: "2px",
                }}
              ></div>
            </div>

            <form onSubmit={(event) => handleSubmit(event)}>
              <Row>
                {/* Profile Section */}
                <Col md={4} className="text-center mb-4">
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    <img
                      src={avatar}
                      alt={"avatar"}
                      style={{
                        width: 160,
                        height: 160,
                        borderRadius: "50%",
                        border: "4px solid #007bff",
                        boxShadow: "0 8px 25px rgba(0, 123, 255, 0.2)",
                        transition: "all 0.3s ease",
                      }}
                      onLoad={() =>
                        console.log("Avatar loaded untuk shift:", shiftType)
                      }
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.05)";
                        e.target.style.boxShadow =
                          "0 12px 35px rgba(0, 123, 255, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                        e.target.style.boxShadow =
                          "0 8px 25px rgba(0, 123, 255, 0.2)";
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "8px",
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        background: "#28a745",
                        border: "3px solid white",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                      }}
                    ></div>
                  </div>

                  <h4
                    style={{
                      color: "#2c3e50",
                      marginTop: "20px",
                      fontWeight: "600",
                      fontSize: "1.3rem",
                    }}
                  >
                    {nama}
                  </h4>
                  {shiftType && (
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "5px 15px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600",
                        background:
                          shiftType === "pagi"
                            ? "rgba(255, 193, 7, 0.2)"
                            : shiftType === "siang"
                            ? "rgba(220, 53, 69, 0.2)"
                            : "rgba(40, 167, 69, 0.2)",
                        color:
                          shiftType === "pagi"
                            ? "#856404"
                            : shiftType === "siang"
                            ? "#721c24"
                            : "#155724",
                        border: `1px solid ${
                          shiftType === "pagi"
                            ? "#ffc107"
                            : shiftType === "siang"
                            ? "#dc3545"
                            : "#28a745"
                        }`,
                      }}
                    >
                      {shiftType === "pagi"
                        ? "🌅 Shift Pagi"
                        : shiftType === "siang"
                        ? "☀️ Shift Siang"
                        : "🌙 Shift Malam"}
                    </div>
                  )}
                </Col>

                {/* Time and Status Section */}
                <Col md={8}>
                  <Row>
                    {/* Time Cards */}
                    <Col md={6} className="mb-4">
                      <div
                        style={{
                          background: "#f8f9fa",
                          borderRadius: "12px",
                          padding: "25px",
                          border: "1px solid #e9ecef",
                          transition: "all 0.3s ease",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-3px)";
                          e.target.style.boxShadow =
                            "0 4px 15px rgba(0,0,0,0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow =
                            "0 2px 8px rgba(0,0,0,0.05)";
                        }}
                      >
                        <div className="text-center">
                          <i
                            className="nc-icon nc-time-alarm"
                            style={{
                              fontSize: "2rem",
                              color: "#007bff",
                              marginBottom: "15px",
                            }}
                          ></i>
                          <h6
                            style={{
                              color: "#495057",
                              marginBottom: "10px",
                              fontWeight: "600",
                            }}
                          >
                            Waktu Masuk
                          </h6>
                          <div
                            style={{
                              fontSize: "1.5rem",
                              fontWeight: "700",
                              color: "#007bff",
                            }}
                          >
                            {waktuMasukKu || "--:--"}
                            {waktuMasukKu &&
                              console.log(
                                "Waktu masuk aktif untuk shift:",
                                shiftType
                              )}
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col md={6} className="mb-4">
                      <div
                        style={{
                          background: "#f8f9fa",
                          borderRadius: "12px",
                          padding: "25px",
                          border: "1px solid #e9ecef",
                          transition: "all 0.3s ease",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-3px)";
                          e.target.style.boxShadow =
                            "0 4px 15px rgba(0,0,0,0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow =
                            "0 2px 8px rgba(0,0,0,0.05)";
                        }}
                      >
                        <div className="text-center">
                          <i
                            className="nc-icon nc-time-alarm"
                            style={{
                              fontSize: "2rem",
                              color: "#dc3545",
                              marginBottom: "15px",
                            }}
                          ></i>
                          <h6
                            style={{
                              color: "#495057",
                              marginBottom: "10px",
                              fontWeight: "600",
                            }}
                          >
                            Waktu Pulang
                          </h6>
                          <div
                            style={{
                              fontSize: "1.5rem",
                              fontWeight: "700",
                              color: "#dc3545",
                            }}
                          >
                            {waktuPulang || "--:--"}
                            {waktuPulang &&
                              console.log(
                                "Waktu pulang aktif untuk shift:",
                                shiftType
                              )}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {/* Working Hours */}
                  <Row className="mb-4">
                    <Col>
                      <div
                        style={{
                          background: "#f8f9fa",
                          borderRadius: "12px",
                          padding: "25px",
                          border: "1px solid #e9ecef",
                          transition: "all 0.3s ease",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-3px)";
                          e.target.style.boxShadow =
                            "0 4px 15px rgba(0,0,0,0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow =
                            "0 2px 8px rgba(0,0,0,0.05)";
                        }}
                      >
                        <div className="text-center">
                          <i
                            className="nc-icon nc-chart-bar-32"
                            style={{
                              fontSize: "2rem",
                              color: "#ffc107",
                              marginBottom: "15px",
                            }}
                          ></i>
                          <h6
                            style={{
                              color: "#495057",
                              marginBottom: "10px",
                              fontWeight: "600",
                            }}
                          >
                            Jam Kerja
                          </h6>
                          <div
                            style={{
                              fontSize: "1.5rem",
                              fontWeight: "700",
                              color: "#ffc107",
                            }}
                          >
                            {workingHours} Jam
                            {workingHours > 0 &&
                              console.log(
                                "Working hours aktif untuk shift:",
                                shiftType
                              )}
                          </div>
                          {shiftType && (
                            <div
                              style={{
                                fontSize: "11px",
                                color: "#6c757d",
                                marginTop: "5px",
                              }}
                            >
                              {shiftType === "pagi"
                                ? "08:00 - 14:00"
                                : shiftType === "siang"
                                ? "14:00 - 20:00"
                                : "20:00 - 08:00 (hari berikutnya)"}
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {/* Status Selection */}
                  <Row className="mb-4">
                    <Col>
                      <div
                        style={{
                          background: "#f8f9fa",
                          borderRadius: "12px",
                          padding: "25px",
                          border: "1px solid #e9ecef",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        }}
                      >
                        <h6
                          style={{
                            color: "#495057",
                            marginBottom: "15px",
                            fontWeight: "600",
                          }}
                        >
                          <i className="nc-icon nc-badge mr-2"></i>
                          Status Kehadiran
                          {shiftType && (
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#6c757d",
                                marginLeft: "10px",
                                fontWeight: "normal",
                              }}
                            >
                              (
                              {shiftType === "pagi"
                                ? "Shift Pagi"
                                : shiftType === "siang"
                                ? "Shift Siang"
                                : "Shift Malam"}
                              )
                            </span>
                          )}
                        </h6>
                        <Input
                          disabled={catatMasukKu ? false : true}
                          type="select"
                          value={status}
                          name="jenis"
                          onChange={(event) => {
                            setStatus(event.target.value);
                            console.log(
                              "Status changed untuk shift:",
                              shiftType,
                              event.target.value
                            );
                            console.log("Edit status untuk shift:", shiftType);
                          }}
                          style={{
                            background: "white",
                            border: "1px solid #ced4da",
                            borderRadius: "8px",
                            color: "#495057",
                            padding: "12px 20px",
                          }}
                        >
                          <option value={""} style={{ color: "#333" }}>
                            - Pilih Status -
                          </option>
                          <option value={"Hadir"} style={{ color: "#333" }}>
                            Hadir
                          </option>
                          <option
                            value={"Dinas Luar"}
                            style={{ color: "#333" }}
                          >
                            Dinas Luar
                          </option>
                          <option value={"Izin"} style={{ color: "#333" }}>
                            Izin
                          </option>
                          <option value={"Sakit"} style={{ color: "#333" }}>
                            Sakit
                          </option>
                          <option
                            value={"Tugas Belajar"}
                            style={{ color: "#333" }}
                          >
                            Tugas Belajar
                          </option>
                          <option
                            value={"Izin Belajar"}
                            style={{ color: "#333" }}
                          >
                            Izin Belajar
                          </option>
                          <option value={"Cuti"} style={{ color: "#333" }}>
                            Cuti
                          </option>
                        </Input>
                      </div>
                    </Col>
                  </Row>

                  {/* Geolocation Section */}
                  <Row className="mb-4">
                    <Col>
                      <div
                        style={{
                          background: "#f8f9fa",
                          borderRadius: "12px",
                          padding: "25px",
                          border: "1px solid #e9ecef",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        }}
                      >
                        <h6
                          style={{
                            color: "#495057",
                            marginBottom: "15px",
                            fontWeight: "600",
                          }}
                        >
                          <i className="nc-icon nc-pin-3 mr-2"></i>
                          Lokasi
                          {shiftType && (
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#6c757d",
                                marginLeft: "10px",
                                fontWeight: "normal",
                              }}
                            >
                              ({shiftType})
                            </span>
                          )}
                        </h6>

                        {isGettingLocation ? (
                          <div className="text-center">
                            <Spinner size="sm" color="primary" />
                            <span
                              style={{ color: "#495057", marginLeft: "10px" }}
                            >
                              Mendapatkan lokasi...
                              {shiftType && ` (${shiftType})`}
                              {isGettingLocation &&
                                console.log(
                                  "Getting location aktif untuk shift:",
                                  shiftType
                                )}
                            </span>
                            {deviceInfo && (isIOS() || isSafari()) && (
                              <div
                                style={{
                                  color: "#fd7e14",
                                  fontSize: "12px",
                                  marginTop: "10px",
                                }}
                              >
                                iOS/Safari detected - mungkin memerlukan waktu
                                lebih lama{shiftType && ` (${shiftType})`}
                                {libur &&
                                  console.log(
                                    "Libur aktif untuk shift:",
                                    shiftType
                                  )}
                              </div>
                            )}
                          </div>
                        ) : geolocationError ? (
                          <div style={{ color: "#dc3545", fontSize: "14px" }}>
                            <i className="nc-icon nc-alert-circle-i mr-2"></i>
                            {geolocationError}
                            {shiftType && ` (${shiftType})`}
                            {geolocationError &&
                              console.log(
                                "Geolocation error aktif untuk shift:",
                                shiftType
                              )}
                            {deviceInfo && isIOS() && (
                              <div
                                style={{
                                  marginTop: "10px",
                                  fontSize: "12px",
                                  color: "#fd7e14",
                                }}
                              >
                                <strong>iOS Device:</strong> Pastikan Location
                                Services aktif di Settings
                                {shiftType && ` (${shiftType})`}
                                {hariLibur &&
                                  console.log(
                                    "Hari libur aktif untuk shift:",
                                    shiftType
                                  )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div>
                            <div
                              style={{
                                color: "#495057",
                                marginBottom: "10px",
                                fontWeight: "600",
                              }}
                            >
                              <strong>Koordinat:</strong>
                            </div>
                            <div
                              style={{
                                background: "white",
                                borderRadius: "8px",
                                padding: "15px",
                                marginBottom: "15px",
                                border: "1px solid #e9ecef",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                              }}
                            >
                              <div
                                style={{ color: "#007bff", fontWeight: "600" }}
                              >
                                {latitude} , {longitude}
                                {shiftType && (
                                  <span
                                    style={{
                                      fontSize: "10px",
                                      color: "#6c757d",
                                      marginLeft: "5px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    ({shiftType})
                                  </span>
                                )}
                                {geolocationSupported &&
                                  console.log(
                                    "Geolocation supported aktif untuk shift:",
                                    shiftType
                                  )}
                              </div>
                              {deviceInfo && (
                                <div
                                  style={{
                                    fontSize: "11px",
                                    color: "#6c757d",
                                    marginTop: "5px",
                                  }}
                                >
                                  Device: {deviceInfo.isIOS ? "iOS" : "Other"} |
                                  Browser:{" "}
                                  {deviceInfo.isSafari ? "Safari" : "Other"}
                                  {shiftType && ` | Shift: ${shiftType}`}
                                  {deviceInfo &&
                                    console.log(
                                      "Device info aktif untuk shift:",
                                      shiftType
                                    )}
                                </div>
                              )}
                            </div>

                            {/* Informasi Jarak ke Kantor */}
                            <div
                              style={{
                                background: "white",
                                borderRadius: "8px",
                                padding: "15px",
                                marginBottom: "15px",
                                border: "1px solid #e9ecef",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                              }}
                            >
                              <div
                                style={{
                                  color: "#495057",
                                  fontWeight: "600",
                                  marginBottom: "8px",
                                  fontSize: "14px",
                                }}
                              >
                                <i className="nc-icon nc-chart-bar-32 mr-2"></i>
                                Jarak ke Kantor:
                                {shiftType && (
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#6c757d",
                                      marginLeft: "5px",
                                      fontWeight: "normal",
                                    }}
                                  >
                                    ({shiftType})
                                  </span>
                                )}
                              </div>
                              <div
                                style={{
                                  color:
                                    jarakKeKantor <= 0.5
                                      ? "#28a745"
                                      : jarakKeKantor <= 1
                                      ? "#ffc107"
                                      : "#dc3545",
                                  fontWeight: "700",
                                  fontSize: "16px",
                                }}
                              >
                                {jarakKeKantor.toFixed(2)} km
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "#6c757d",
                                    marginLeft: "5px",
                                    fontWeight: "normal",
                                  }}
                                >
                                  {jarakKeKantor <= 0.5
                                    ? "(Dalam radius kantor)"
                                    : jarakKeKantor <= 1
                                    ? "(Jarak sedang)"
                                    : "(Jarak jauh)"}
                                </span>
                                {jarakKeKantor > 0 &&
                                  console.log(
                                    "Jarak ke kantor aktif untuk shift:",
                                    shiftType
                                  )}
                              </div>
                              <div
                                style={{
                                  marginTop: "8px",
                                  padding: "5px 10px",
                                  borderRadius: "4px",
                                  fontSize: "11px",
                                  fontWeight: "500",
                                  background:
                                    jarakKeKantor <= 0.5
                                      ? "rgba(40, 167, 69, 0.1)"
                                      : jarakKeKantor <= 1
                                      ? "rgba(255, 193, 7, 0.1)"
                                      : "rgba(220, 53, 69, 0.1)",
                                  color:
                                    jarakKeKantor <= 0.5
                                      ? "#28a745"
                                      : jarakKeKantor <= 1
                                      ? "#856404"
                                      : "#721c24",
                                  border: `1px solid ${
                                    jarakKeKantor <= 0.5
                                      ? "#28a745"
                                      : jarakKeKantor <= 1
                                      ? "#ffc107"
                                      : "#dc3545"
                                  }`,
                                }}
                              >
                                {jarakKeKantor <= 0.5
                                  ? "✓ Lokasi dalam radius kantor"
                                  : jarakKeKantor <= 1
                                  ? "⚠ Jarak sedang dari kantor"
                                  : "✗ Lokasi jauh dari kantor"}
                              </div>
                              <div>
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "#6c757d",
                                    marginTop: "3px",
                                  }}
                                >
                                  Koordinat Kantor: {coordsKantor.lat},{" "}
                                  {coordsKantor.long}
                                  {shiftType && ` | Shift: ${shiftType}`}
                                  {coordsKantor.lat &&
                                    console.log(
                                      "Koordinat kantor aktif untuk shift:",
                                      shiftType
                                    )}
                                </span>
                              </div>
                            </div>
                            <Button
                              size="sm"
                              onClick={getCurrentLocation}
                              style={{
                                background: "#007bff",
                                border: "none",
                                borderRadius: "8px",
                                padding: "8px 20px",
                                color: "white",
                                transition: "all 0.3s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.transform = "translateY(-2px)";
                                e.target.style.boxShadow =
                                  "0 4px 12px rgba(0,123,255,0.3)";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.transform = "translateY(0)";
                                e.target.style.boxShadow = "none";
                              }}
                            >
                              <i className="nc-icon nc-refresh-69 mr-2"></i>
                              Refresh Lokasi{shiftType && ` (${shiftType})`}
                            </Button>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Action Buttons */}
              <Row className="mt-4">
                <Col className="text-center">
                  {sementaraLoading ? (
                    <Button
                      color="primary"
                      type="submit"
                      disabled
                      style={{
                        background: "#6c757d",
                        border: "none",
                        borderRadius: "12px",
                        padding: "15px 40px",
                        fontSize: "1.1rem",
                        opacity: "0.7",
                      }}
                    >
                      <Spinner size="sm" color="light" /> Loading ...
                      {shiftType && ` (${shiftType})`}
                    </Button>
                  ) : (
                    <>
                      {catatMasukKu ? (
                        <Button
                          type="submit"
                          style={{
                            background: "#007bff",
                            border: "none",
                            borderRadius: "12px",
                            padding: "15px 40px",
                            fontSize: "1.1rem",
                            fontWeight: "600",
                            boxShadow: "0 4px 15px rgba(0,123,255,0.3)",
                            transition: "all 0.3s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.transform = "translateY(-3px)";
                            e.target.style.boxShadow =
                              "0 8px 25px rgba(0,123,255,0.4)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow =
                              "0 4px 15px rgba(0,123,255,0.3)";
                          }}
                        >
                          <i className="nc-icon nc-single-02 mr-2"></i>
                          {saveLoading ? (
                            <>
                              <Spinner size="sm" color="light" /> Loading
                              {shiftType && ` (${shiftType})`}
                            </>
                          ) : (
                            `Catat Masuk ${shiftType ? `(${shiftType})` : ""}`
                          )}
                        </Button>
                      ) : null}

                      {catatPulangkuKu ? (
                        <Button
                          type="submit"
                          style={{
                            background: "#dc3545",
                            border: "none",
                            borderRadius: "12px",
                            padding: "15px 40px",
                            fontSize: "1.1rem",
                            fontWeight: "600",
                            boxShadow: "0 4px 15px rgba(220,53,69,0.3)",
                            transition: "all 0.3s ease",
                            marginLeft: "15px",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.transform = "translateY(-3px)";
                            e.target.style.boxShadow =
                              "0 8px 25px rgba(220,53,69,0.4)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow =
                              "0 4px 15px rgba(220,53,69,0.3)";
                          }}
                        >
                          <i className="nc-icon nc-single-02 mr-2"></i>
                          {saveLoading ? (
                            <>
                              <Spinner size="sm" color="light" /> Loading
                              {shiftType && ` (${shiftType})`}
                            </>
                          ) : (
                            `Catat Pulang ${shiftType ? `(${shiftType})` : ""}`
                          )}
                        </Button>
                      ) : null}
                    </>
                  )}
                </Col>
              </Row>
            </form>
          </div>
        </Col>
      </Row>

      {/* CSS Animation */}
      <style>
        {`
          .content {
            animation: fadeIn 0.6s ease-in-out;
          }
          
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}
